import { Component } from "@angular/core";
import { FieldType } from "@kre-form/core";

@Component({
  selector: "kreform-field-ion-switch",
  template: `
    <ng-container *ngIf="!!editor; else other">
      <ion-toggle
        [formControl]="formControl"
        [ionKreFormAttributes]="field"
      ></ion-toggle>
    </ng-container>
    <ng-template #other>
      <div class="fieldtext">{{text }}</div>
    </ng-template>
  `,
})
export class KreFormFieldIonSwitch extends FieldType {
  constructor() {
    super();
  }
  switchValue(): string {
    if (!!this.model[this.field.key]) {
      return "是";
    } else {
      return "否";
    }
  }
}
